module.exports = __webpack_public_path__ + "img/api-community.5150aeec.svg";